<template>
  <div class="home">
    <div class="card-body" v-if="mainData!=undefined">
      <div class="section">
        <h3>区域信息</h3>
        <div class="info-grid">
          <div class="info-label">名称</div>
          <div class="info-value">{{ mainData[0].place.placeName }}</div>
          <div class="info-label">联系人</div>
          <div class="info-value">{{ mainData[0].place.contactName }}</div>
          <div class="info-label">信用代码</div>
          <div class="info-value">{{ mainData[0].place.licenseNumber }}</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="section">
        <div class="info-grid">
          <div class="info-label">区域</div>
          <div class="info-value">{{ mainData[0].place.addressDetail }}</div>
        </div>
      </div>
    </div>
    <div class="card-body" v-else>
      <div class="section">
        <h3>区域信息</h3>
        <div class="info-grid">
          <div class="info-label">名称</div>
          <div class="info-value"></div>
          <div class="info-label">联系人</div>
          <div class="info-value"></div>
          <div class="info-label">信用代码</div>
          <div class="info-value"></div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="section">
        <div class="info-grid">
          <div class="info-label">区域</div>
          <div class="info-value"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isPreviewOpen" class="preview-modal" @click="closePreview">
    <img class="preview-content" mode="aspectFill" :src="url"/>
  </div>
</template>
<script>
export default {
  name: 'MerchantCard',
  props: {
    mainData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      url: '',
      isPreviewOpen: false
    }
  },
  methods: {
    openPreview(url) {
      this.url = url
      this.isPreviewOpen = true
      document.body.style.overflow = 'hidden'
    },
    closePreview() {
      this.isPreviewOpen = false
      document.body.style.overflow = ''
    }
  }
}
</script>
<style scoped>
.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-content {
  max-width: 90%;
  max-height: 90%;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
}

.card-body {
  padding: 20px;
}

.section {
  margin-bottom: 15px;
}

.section h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.info-grid {
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 10px;
}

.info-label {
  font-weight: bold;
  color: #666;
}

.info-value {
  color: #333;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 15px 0;
}
</style>
